import { useId } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import type { CoinType } from '../../../stores/cointype/CoinTypeStore';
import { formatValueWithK } from '../../../utils/helpers';
import { formatTime } from '../../../utils/time';
import { I18Text } from '../../i18Next/I18Text';
import { SocialCoin } from '../../SocialCoin/SocialCoin';
import { SweepCoin } from '../../SweepCoin/SweepCoin';

import { CircleIcon } from './CircleIcon';
import styles from './freeSpinsIconNew.module.scss';
import { OutlineText } from './OutlineText';

type Props = {
  gameImage: string;
  betAmount: number;
  spinsCount: number;
  betCoinType: CoinType;
  type: 'freeSpins' | 'countdown';
  countdownSeconds: number;
};
export const FreeSpinsIconNew = ({ gameImage, spinsCount, betCoinType, betAmount, type, countdownSeconds }: Props) => {
  const { t } = useTranslation();
  const CoinIcon = betCoinType === 'GC' ? SocialCoin : SweepCoin;
  const artMaskId = `frb-art-mask-${useId().replace(/:/g, '')}`;
  return (
    <div className={styles.wrapper}>
      <div className={classNames(styles.iconContainer, 'frb-widget-new')}>
        <CircleIcon className={styles.circle} />
      </div>
      <svg className={styles.artMaskDefs}>
        <clipPath clipPathUnits="objectBoundingBox" id={artMaskId}>
          <rect height="0.87" rx="0.08" ry="0.09" width="1" />
          <ellipse cx="0.5" cy="0.94" rx="0.5" ry="0.58" />
        </clipPath>
      </svg>
      <div className={classNames(styles.artMask, 'frb-widget-new-game-image-container')}>
        <div className={styles.artClip} style={{ clipPath: `url(#${artMaskId})` }}>
          <img alt="game image" className={styles.slotArt} src={gameImage} />
        </div>
      </div>
      <div className={styles.freeSpinsType}>
        {type === 'freeSpins' && (
          <div className={styles.spinsCount}>
            <OutlineText text={`${spinsCount}`} />
          </div>
        )}
        <div className={styles.text}>
          <I18Text i18nKey="frb.freeSpins" />
        </div>

        {type === 'freeSpins' && (
          <div className={styles.betAmount}>
            <CoinIcon className={styles.coin} />
            <span className={styles.value}>{formatValueWithK(Number(betAmount), t)}</span>
          </div>
        )}
        {type === 'countdown' && (
          <div className={styles.countdown}>
            <p>{formatTime(countdownSeconds, 's', t)}</p>
          </div>
        )}
      </div>
    </div>
  );
};
